import type { Schema } from '@biteinc/common';

export function buildQuicksandRecordListFilterSchema(): Schema.ModelTypedObjectField {
  const schema: Schema.ModelTypedObjectField = {
    type: 'object',
    fields: {
      fromTimestamp: {
        type: 'timestamp',
        displayName: 'From',
        futureDateLimit: 'disallowed',
        useSiteTimezone: true,
      },
      toTimestamp: {
        type: 'timestamp',
        displayName: 'To',
        futureDateLimit: 'disallowed',
        useSiteTimezone: true,
      },
      syncedBy: {
        type: 'keyString',
        displayName: 'Synced By',
        tooltip: {
          text: '"automatic", "webhook", "manual", or a Bite username',
        },
      },
    },
  };
  return schema;
}
